module.exports = __webpack_public_path__ + "media/1000_HC_2023_Password_Security.65df4b88.mp4";